import { render, staticRenderFns } from "./CoveragesView.vue?vue&type=template&id=17bf01c4&"
import script from "./CoveragesView.vue?vue&type=script&lang=js&"
export * from "./CoveragesView.vue?vue&type=script&lang=js&"
import style0 from "./CoveragesView.vue?vue&type=style&index=0&id=17bf01c4&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports